<script>
  export default {
    name: 'detail-row',
    props: {
      rowData: {
        type: Object,
        required: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/metawesome-datatable/src/DetailRow.vue